<template>
  <v-layout row :class="{'minimalHeight': $vuetify.breakpoint.xs}">
    <v-flex xs5 sm6 md6 class="pl-3 pr-1 type-value">
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title
            style="white-space: normal;"
          >{{product.productLabel}}</v-list-item-title>
          <v-list-item-subtitle
            style="white-space: normal;"
          >{{product.productDescription}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-flex>
    <v-flex xs2 sm2 md2 class="px-1 centered-vertically">
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title style="white-space: normal;">{{product.price.toFixed(2).toString()}}</v-list-item-title>
          <v-list-item-subtitle style="white-space: normal;">excl. VAT (21%)</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-flex>
    <v-flex xs5 sm3 md3 class="pl-1 centered-vertically">
      <PlusMinusInput :max="60" :value="inputValue" @change="updateProductCount" />
    </v-flex>

  </v-layout>
</template>

<script>
import PlusMinusInput from '@/components/PlusMinusInput';

export default {
  name: 'Product',
  components: {
    PlusMinusInput,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    inputValue: function() {
      return this.value;
    },
  },
  methods: {
    updateProductCount(value) {
      this.$emit('change', {
        productType: this.product.productType,
        amount: value,
      });
    },
  },
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
.type-count,
.type-price {
  margin-left: 0;
}

.v-list-item {
  padding: 0px;
}

.centered-vertically{
   display: flex;
   align-items: start;
}

.minimalHeight{
  min-height: 100px;
}
</style>
